import React from 'react';
import './offerActivities.scss';

import { useState, useEffect, useCallback} from "react";

import DataGrid, {
  Column,
  Button,
  Editing,
  Toolbar,
  Selection,
  Lookup, 
  HeaderFilter,
  SearchPanel,
  Scrolling,
  //Item,
  Form as GridForm
} from 'devextreme-react/data-grid';

import { createStore } from 'devextreme-aspnet-data';

import {
  Item,
  CustomRule,
  RequiredRule
} from 'devextreme-react/form';

import { CheckBox } from 'devextreme-react/check-box';
import {Logout, IsRole_Admin, IsRole_SalesManager, tipoAttivitaOptions,statoNotificaAttivitaOptions,SevenDaysFormatted, TodayFormatted} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

const debug = process.env.ENTITY_DEBUG;

export default function OfferActivities(props) {

  var attivitaDataGridRef = React.createRef();

  const [collaboratori, setCollaboratori] = useState({});
  const [isIncludeCompleted, setIsIncludeCompleted] = useState(false);

  const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_OfferteAttivita'
  const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaAttivita'
  const { user } = useAuth(); 

  if (!user) 
    Logout();

  const isSalesManager=IsRole_SalesManager();
  const isAdmin=IsRole_Admin();

  const filterPayload = { 
    storico: isIncludeCompleted
  };

  const remoteDataSource = createStore({
      
    // key: 'id',
    // loadUrl: serviceUrl + '/GetAction',
    // onBeforeSend: (method, ajaxOptions) => {
    // ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    // },  

    key: 'id',
    loadUrl: serviceUrl + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },

    insertUrl: serviceUrl2 + '/InsertAction',
    updateUrl:serviceUrl2 + '/UpdateAction',
    deleteUrl: serviceUrl2 + '/DeleteAction'
      
  });

  useEffect(() => {
      
    const fetchData = async () => {

      const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
      var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";
      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };
      
        const response3 = await fetch(newUrl3,requestOptions);
        const json3 = await response3.json();
        if (debug === 1)
          console.log(json3);
        setCollaboratori(json3);
      } catch (error) {
        console.log("error", error);
      }
    };
  
      fetchData();
  }, []);

  function onCheckValueChanged(e)  {
    setIsIncludeCompleted(e.value);
  };

  const validateCompletata = (e) => {

    var isCompletata = e.value;
    console.log("isCompletata:" + isCompletata);
    var scadenza = e.data.dataScadenza;
    if(scadenza === undefined )
      return true;
    console.log("scadenza:" + scadenza);
    if (scadenza !== null && isCompletata === false) 
      return false;
    else
      return true;
  };

  const onCellPreparedGrid = (e) => {
      
    if (e.rowType === "data") {
      if (e.column.dataField === "dataAttivita") { 
        var isCompletata = e.data.completata;
        var dataAttivita = e.data.dataAttivita;

        if (isCompletata)
        {
          e.cellElement.style.cssText = "color: lightgreen;font-weight: bold";
        }
        else if (dataAttivita < TodayFormatted())
        {
          e.cellElement.style.cssText = "color: red; font-weight: bold";
        }
        else if ((dataAttivita < SevenDaysFormatted()) &&  (dataAttivita > TodayFormatted()) )
        {
          e.cellElement.style.cssText = "color: orange; font-weight: bold";
        }
      
      }
    }

  }

  const showEditButton = useCallback((e) => {
    if (isSalesManager || isAdmin)
      return true
    else
    {
      //console.log("SHOW " + e.row.data.completata)
      return e.row.data.completata === false;
    }
  }, []);

  const onEditorPreparing = (e) => { 
    if (e.parentType == 'dataRow' && e.dataField == 'descrizione') {  
      e.editorOptions.maxLength = 400;  
    }  
  }  
  
  return (
  <React.Fragment>
    <h2 className={'content-block'}>Attività offerte</h2>
    <div className={'content-block'}>
      <div className="dx-card responsive-paddings">
        
        <DataGrid id="grid-subcontainer"
          dataSource={remoteDataSource}
          //height={400}   
          //onRowInserting={onRowInserting}
          //onInitNewRow={handleInitNewRow}
          showBorders={true}
          onCellPrepared={onCellPreparedGrid}
          dateSerializationFormat= {'yyyy-MM-dd'}
          ref={ref => attivitaDataGridRef = ref}
          onEditorPreparing={onEditorPreparing}
        >
          <Selection mode="single" />
          <SearchPanel visible={true}
            width={240}
            placeholder="Cerca..."
          />
          <Toolbar>
          <Item location="after">
            <CheckBox  
              value={isIncludeCompleted} onValueChanged={onCheckValueChanged}
              defaultValue={isIncludeCompleted}
              text="  Includi completate   "
            >
            </CheckBox>
          </Item>    
            <Item name="searchPanel" className="offer-toolbar"/>
          </Toolbar>
          <HeaderFilter visible={true} />
    
          <Editing
            mode="form"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={true}
            useIcons={true}
          >
            <GridForm>
              <Item dataField="dataAttivita" />
              <Item dataField="collaboratoreId" />
              <Item dataField="tipoAttivitaId" />
              <Item dataField="riferimentoCliente" />
              <Item dataField="descrizione" colSpan={2}/>
              <Item dataField="dataScadenza" />
              <Item dataField="completata" editorType='dxCheckBox'></Item>
              <Item dataField="statoNotificaId" />
              <Item dataField="statoNotifica2Id" />
            </GridForm>

          </Editing>

          <Column dataField="id" visible={false}/>
          
          <Column dataField="dataAttivita" dataType="date" format= {'dd/MM/yyyy'} caption="Data attività" width={120} >
            <RequiredRule/>
          </Column>
          <Column dataField="numero" width={80} caption="Offerta"/>
          <Column dataField="oggetto"  caption="Progetto"  width={280}/>
          <Column dataField="collaboratoreId" caption="Assegnatata a" width={140} >
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
            <RequiredRule/>
          </Column>
          <Column dataField="tipoAttivitaId" caption="Tipo Attività" visible={false}>
            <Lookup dataSource={tipoAttivitaOptions} displayExpr="desc" valueExpr="id" />
            <RequiredRule/>
          </Column>
          <Column dataField="descrizione" caption = "Attività">
            <RequiredRule/>
          </Column>
          <Column dataField="riferimentoCliente" caption = "Rif. Cliente" width={120} visible={false}/>
          <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} caption="Follow up" width={120}/>
          <Column dataField="completata" width={90} caption="Completata">
            <CustomRule type="custom" message={"L'attività deve essere completata se è previsto un Follow-up"} validationCallback={validateCompletata} />
          </Column>
          <Column dataField="statoNotificaId" caption="Notifica al DC" visible={false} >
            <Lookup dataSource={statoNotificaAttivitaOptions} displayExpr="desc" valueExpr="id" />
          </Column>
           <Column dataField="statoNotifica2Id" caption="Notifica all'assegnatario" visible={false} >
            <Lookup dataSource={statoNotificaAttivitaOptions} displayExpr="desc" valueExpr="id" />
          </Column>
          <Column dataField="createBy" visible={false}/>
          <Column type="buttons">
            <Button name="edit" visible={showEditButton} />
            <Button name="delete" visible={showEditButton}/>
          </Column>

        </DataGrid>

      </div>
    </div>
  </React.Fragment>
)};
